import { Link, Navigate } from "react-router-dom";
import { CourseCard, CourseComing } from "../home/StudentHome";
import { useLms } from "./LmsShell";
import PageFrame, { LoadFailed, Loading } from "./PageFrame";

/**
 * Sidebar "My courses": with one current course it opens that course page (as in the prototype);
 * otherwise it lists every course as Home's course cards.
 */
export default function MyCoursesPage() {
  const { overview, overviewError, reloadOverview } = useLms();
  const intro = "Every course you're taking or have finished. Open one to see its weeks, activities and grades.";

  if (overviewError) return <PageFrame title="My courses" intro={intro}><LoadFailed what="courses" onRetry={reloadOverview} /></PageFrame>;
  if (!overview) return <PageFrame title="My courses" intro={intro}><Loading /></PageFrame>;

  const courses = overview.courses || [];
  const active = courses.filter((c) => c.status === "active");
  if (active.length === 1) return <Navigate to={`/dashboard/course/${active[0].course.uuid}?cohort_id=${active[0].cohort.id}`} replace />;

  return (
    <PageFrame title="My courses" intro={intro}>
      {(overview.waiting || []).map((w) => <CourseComing key={w.id} cohort={w} />)}
      {courses.length ? (
        <div className="courses">{courses.map((c) => <CourseCard key={`${c.course.uuid}-${c.cohort.id}`} c={c} />)}</div>
      ) : overview.waiting?.length ? null : (
        <section className="complete-box">
          <div><strong>You're not enrolled in a course yet</strong><small>Browse our courses and join the next cohort.</small></div>
          <Link className="cbtn go" to="/courses/categories">Browse courses</Link>
        </section>
      )}
    </PageFrame>
  );
}
